// import { MainContentLayout } from 'shared/ui/layout';

import { EditChargePointsGroup } from 'features/charge-points-group/edit';

export function EditChargePointsGroupPage() {
  return <EditChargePointsGroup />;
}
